module.exports = __webpack_public_path__ + "img/curLocation.13488299.png";